module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "f2 lh-copy pt3 tl-ns tc tc-m"
  }, [_vm._v("Claim Submitted")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "w-100 flex flex-row justify-around"
  }, [_c('a', {
    staticClass: "db color-theme no-underline mt2 cera-round-pro-medium",
    attrs: {
      "href": "mailto:claims+support@getakko.com",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Email Support")]), _vm._v(" "), _c('a', {
    staticClass: "db color-theme no-underline mt2 cera-round-pro-medium pointer",
    nativeOn: {
      "click": function($event) {
        return _vm.openIntercomChat.apply(null, arguments)
      }
    }
  }, [_vm._v("Chat Support")])]), _vm._v(" "), _c('hr', {
    staticClass: "center mv4 hr"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "lh-copy black mb2"
  }, [_vm._v("\n    Make sure you have all the information and documents needed to complete filing your claim. The claims agent assigned to your claim may request more information.\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "lh-copy black mb2"
  }, [_vm._v("\n    Expect to receive a reply within approximately 2-4 business days of filing your claim.\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "lh-copy black mb2"
  }, [_vm._v("\n    Your plan protects your covered property worldwide. If your loss happened outside of the U.S., a police report is required in order to file a claim.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "mb4 flex flex-row items-center"
  }, [_c('router-link', {
    staticClass: "no-underline",
    attrs: {
      "to": _vm.featureFlagRedirectClaimV2 ? '/claims-v2' : '/claims'
    }
  }, [_c('ak-button', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("Back to Claims")])], 1), _vm._v(" "), _c('a', {
    staticClass: "db color-theme no-underline mt2 cera-round-pro-medium pointer ml3",
    nativeOn: {
      "click": function($event) {
        return _vm.openIntercomChat.apply(null, arguments)
      }
    }
  }, [_vm._v("I still have questions")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tl-ns tc tc-m"
  }, [_c('img', {
    staticClass: "claim-logo",
    attrs: {
      "src": "/static/icons/claim-info.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "black f5 mb4 lh-copy"
  }, [_vm._v("\n    We’re here to make the process of filing a claim and getting your repairs/replacements completed as quickly and easily as possible!\n    "), _c('br'), _vm._v("\n    If you need any assistance with this process, just reach out to us and we’ll walk you through each step!\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-100 mb3 tl-ns tc tc-m"
  }, [_c('h2', [_vm._v("IMPORTANT")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-863291fc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-863291fc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClaimInfoPage.vue
// module id = 1560
// module chunks = 0